<div class="flex h-full min-h-0 flex-col">
<div class="flex min-h-0 flex-1 flex-col gap-5 overflow-y-auto p-4">
@if (briefType(); as type) {
    <div>
        <p class="text-xs font-semibold uppercase tracking-widest text-brand-studio">Live brief</p>
        @if (draft()?.title) {
        <h2 class="mt-2 font-heading text-2xl font-bold leading-none tracking-tight text-primary">{{ draft()?.title }}</h2>
        }
        <p class="mt-1 font-heading text-lg font-bold leading-none text-primary">{{ headerType(type) }}</p>
        @if (progress(); as progress) {
        <div class="mt-3 flex items-center gap-3" role="progressbar"
            [attr.aria-valuenow]="progress.current" aria-valuemin="1" [attr.aria-valuemax]="progress.total"
            [attr.aria-label]="'Step ' + progress.current + ' of ' + progress.total">
            <div class="h-1.5 min-w-0 flex-1 overflow-hidden rounded-full bg-muted">
                <div class="h-full rounded-full bg-brand-studio" [style.width.%]="progress.current / progress.total * 100"></div>
            </div>
            <span class="shrink-0 text-xs text-secondary">{{ progress.current }} of {{ progress.total }}</span>
        </div>
        }
    </div>

    @for (section of sections(); track section.id) {
    <section class="flex flex-col gap-2">
        <h3 class="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-secondary">
            @if (section.id === 'read') {
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-linecap="round" stroke-linejoin="round" class="size-3.5 text-brand-studio" aria-hidden="true">
                <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
            </svg>
            }
            {{ section.title }}
        </h3>
        @for (item of section.cards; track item.id) {
        <article class="rounded-xl border border-border bg-card p-3 dark:border-white/10 dark:bg-white/5">
            <div class="flex items-center justify-between gap-2">
                <h4 class="text-sm font-semibold text-primary">{{ item.title }}</h4>
                @if (item.badge === 'you') {
                <span class="inline-flex items-center gap-1 text-xs text-secondary">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-linecap="round" stroke-linejoin="round" class="size-3.5" aria-hidden="true">
                        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                    </svg>
                    You
                </span>
                } @else {
                <span class="inline-flex items-center gap-1 rounded-full bg-brand-studio/10 px-2 py-0.5 text-xs font-medium text-brand-studio">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-linecap="round" stroke-linejoin="round" class="size-3" aria-hidden="true">
                        <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                    </svg>
                    From brief
                </span>
                }
            </div>

            @if (item.kind === 'product') {
            @if (item.productName) {
            <div class="mt-2 flex items-center gap-3">
                <span class="flex size-11 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-muted text-secondary">
                    @if (item.productImage) {
                    <img [src]="productImageUrl(item.productImage)" alt="" class="size-full object-cover" />
                    } @else {
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                        <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                        <circle cx="9" cy="9" r="2" />
                        <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
                    </svg>
                    }
                </span>
                <span class="min-w-0 flex-1">
                    <span class="block text-sm font-semibold text-primary">{{ item.productName }}</span>
                    @if (item.productDescription) {
                    <span class="block truncate text-xs text-secondary">{{ item.productDescription }}</span>
                    }
                </span>
                @if (item.productPrice) {
                <span class="shrink-0 text-sm font-semibold text-primary">{{ item.productPrice }}</span>
                }
            </div>
            <div class="mt-3 flex flex-wrap items-center gap-2">
                <button type="button" class="btn-shout btn-shout-xs btn-shout-tertiary" (click)="changeProduct.emit()">Change product</button>
                <button type="button" class="btn-shout btn-shout-xs btn-shout-secondary" (click)="addProduct.emit()">Add new</button>
            </div>
            } @else {
            <p class="mt-2 text-sm text-secondary">Not set yet</p>
            }
            } @else if (item.lines.length === 0) {
            <p class="mt-2 text-sm text-secondary">Not set yet</p>
            } @else if (item.lines.length === 1 && item.kind === 'text') {
            <p class="mt-2 text-sm text-primary">{{ item.lines[0] }}</p>
            } @else {
            <ul class="mt-2 flex flex-col gap-1">
                @for (line of visibleLines(item); track $index) {
                <li class="flex items-start gap-2 text-sm text-primary">
                    <span class="mt-1.5 size-1.5 shrink-0 rounded-full bg-brand-studio" aria-hidden="true"></span>
                    <span>{{ line }}</span>
                </li>
                }
            </ul>
            @if (hasMorePoints(item)) {
            <button type="button" class="btn-shout btn-shout-xs btn-shout-tertiary mt-2" (click)="togglePoints(item.id)"
                [attr.aria-expanded]="pointsOpen(item.id)">
                {{ pointsOpen(item.id) ? 'Show less' : 'Show more' }}
            </button>
            }
            }

            @if (item.kind === 'pieces' && type === 'ugc') {
            <div class="mt-3 flex flex-wrap items-center justify-between gap-2">
                <button type="button" class="btn-shout btn-shout-xs btn-shout-tertiary" (click)="editPieces.emit()">Edit placements & deliverables</button>
                @if (item.meta) {
                <span class="text-xs text-secondary">{{ item.meta }}</span>
                }
            </div>
            }
        </article>
        }
        @if (section.id === 'campaign' && type === 'ugc') {
        <cbss-ugc-create-panel [savedCampaignId]="savedCampaignId()" [savedPricingModelId]="savedPricingModelId()" />
        }
    </section>
    }
}
</div>
<footer class="shrink-0 border-t border-border px-4 py-4">
    <button type="button" class="btn-shout btn-shout-md btn-shout-primary w-full justify-center" [disabled]="!canPublish()" (click)="publish.emit()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="size-4" aria-hidden="true">
            <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
            <path d="M20 2v4" />
            <path d="M22 4h-4" />
        </svg>
        Publish brief
    </button>
    @if (!canPublish()) {
    <p class="mt-2 text-center text-sm text-secondary">Finish the chat to create your brief</p>
    }
</footer>
</div>
